import React from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import ArrivePay from 'components/LandingPageArrivePay';
import Styles from './styles.js';
const ArrivePays = ({
  title,
  imgOne,
  headingOne,
  txtOne,
  imgTwo,
  headingTwo,
  txtTwo,

  imgFive,
  headingFive,
  txtFive,
}) => {
  return (
    <div>
      <HeadingSection title={title} bgcolor="white" />
      <div className="lg:container px-6 lg:px-5 mx-auto pt-3 2xl:px-4">
        <div className="flex justify-center   2xl:px-4">
          <div className="">
            <ArrivePay imgsrc={imgOne} title={headingOne} discription={txtOne} reverse={false} />
            <ArrivePay imgsrc={imgTwo} title={headingTwo} discription={txtTwo} reverse={true} />

            <ArrivePay imgsrc={imgFive} title={headingFive} discription={txtFive} reverse={false} />
          </div>
        </div>
      </div>
      <Styles/>
    </div>
  );
};

export default ArrivePays;
